import Checkbox from '@grnhse/seedling/lib/birch/components/checkbox';
import React from 'react';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import { PageName } from '../../shared/types';

type Props = {
  pageName: PageName;
};

const ReferralsCheckbox = ({ pageName }: Props) => {
  const { watch, setValue } = useFormContext();
  const onlyShowReferrals: boolean = watch('referrals_only');

  const t = withLocalePrefix(`talent_${pageName}.labels`);

  return (
    <Checkbox
      data-provides={`talent-${pageName}-referrals-only-checkbox`}
      checked={onlyShowReferrals}
      onChange={(checked) =>
        setValue('referrals_only', checked, { shouldDirty: true })
      }
      label={t('referrals_only')}
      value={'only_show_referrals'}
    />
  );
};

export default ReferralsCheckbox;
